module.exports = __webpack_public_path__ + "static/media/PFHandbookProThin.a5f7a9f8.woff";